import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuthProvider from './AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './components/Dashboard/Dashboard';
import NewMachineDashboard from './components/Machine/MachineDashboard';
import DashboardLayout from './components/DashboardLayout';
import SignIn from './components/Auth/SignIn';
import MachineList from './components/Machine/MachineList';
import LMBLogging from './components/Berende/LMB-Logging';
import LMBLoggingDashboard from './components/Berende/LMB-LoggingDashboard';
import NieuweMachine from './components/Machine/NieuweMachine';
import EditMachine from './components/Machine/EditMachine';
import Organization from './components/Organization/Organization';
import Handleiding from './components/Components/Handleiding';
import Users from './components/Users/Users';
import NieuweLMBLogging from './components/Berende/NieuweLMB-Logging';
import NieuweOrganization from './components/Organization/NieuweOrganization';
import NieuweApi from "./components/Api/NieuwApi";
import Api from "./components/Api/Api";
import HulpstukInfo from './components/Machine/HulpstukInfo';

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/signin" element={<SignIn />} />
          <Route path="/" element={<ProtectedRoute />}>
            <Route element={<DashboardLayout />}>
              <Route index element={<Dashboard />} />

              <Route path="machine" element={<MachineList />} />
              <Route path="machine/handleiding" element={<Handleiding />} />
              <Route path="machine/nieuw" element={<NieuweMachine />} />
              <Route path="machine/hulpstuk/:serialNumber" element={<HulpstukInfo />} />
              <Route path="machine/edit/:serialNumber" element={<EditMachine />} />
              <Route path="machine/:serialNumber" element={<NewMachineDashboard />} />

              <Route path="lmb-logging" element={<LMBLogging />} />
              <Route path="lmb-logging/nieuw" element={<NieuweLMBLogging />} />
              <Route path="lmb-logging/:alias" element={<LMBLoggingDashboard />} />

              <Route path="organization" element={<Organization />} />
              <Route path="organization/nieuw" element={<NieuweOrganization />} />

              <Route path="api" element={<Api />} />
              <Route path="api/nieuw" element={<NieuweApi />} />

              <Route path="users" element={<Users />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
